import React, { useContext, useEffect, useRef, useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthContext } from '../../contexts/authContext'
import styles from './styles.module.css'
import { useToggleHotDropdown } from '../../hooks/useToggleHotDropdown'
import { useResponsiveHotDropdown } from '../../hooks/useResponsiveHotDropdown'
import { getNameInitials } from '../../utils/string'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AuthHeaderUserMenuItem from './AuthHeaderUserMenuItem'
import { faUser, faSignOut, faQuestionCircle, faCommentAlt } from '@fortawesome/pro-light-svg-icons'

function AuthHeaderUserMenu({ tabIndex }) {
  const { t } = useTranslation()
  const hotDropdownRef = useRef()
  const [profile, setProfile] = useState()

  const { user, bootstrap } = useContext(AuthContext)
  const { toggle } = useToggleHotDropdown(hotDropdownRef)
  useResponsiveHotDropdown(hotDropdownRef, { maxHeight: 992 })

  const { userItems } = useMemo(
    () => ({
      userItems: [
        {
          id: 'menu-user-credentials',
          title: t('header.menu.user.myAccount'),
          route: process.env.URL_MY_ACCOUNT,
          icon: faUser,
        },
        {
          id: 'menu-user-feedback',
          title: t('header.menu.user.giveFeedback'),
          route: process.env.URL_FEEDBACK,
          icon: faCommentAlt,
        },
        {
          id: 'menu-user-help',
          title: t('header.menu.general.help'),
          route: process.env.URL_HELP,
          icon: faQuestionCircle,
        },
      ],
    }),
    [t]
  )

  function handleUserKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      toggle()
    }
  }

  useEffect(() => {
    if (user && user.profile) {
      setProfile(user.profile)
    }
  }, [user, profile])

  return (
    <hot-dropdown ref={hotDropdownRef} onKeyDown={handleUserKeyDown} class={`${styles.headerUser} hot-dropdocked`} tabIndex={tabIndex}>
      <hot-menu-item slot="button" class="_cursor-pointer">
        <div className="hot-application-menu__icon">
          <hot-tooltip content={profile?.name} position="bottom" class="_d-flex">
            <hot-avatar class="hot-avatar--sm hot-avatar--text _rounded-circle" src={profile?.urlPhoto} alt="">
              <span>{getNameInitials(profile?.name)}</span>
            </hot-avatar>
          </hot-tooltip>
        </div>
      </hot-menu-item>

      <div slot="menu" className="_mx-5 _my-3">
        <section className="_d-flex _align-items-center _mb-4">
          <hot-avatar class="hot-avatar--xl hot-avatar--text _rounded-circle" src={profile?.urlPhoto}>
            <span>{getNameInitials(profile?.name)}</span>
          </hot-avatar>
          <span className="_ml-4 _font-weight-light _text-truncate _text-gray-500">
            <p className="_mb-0 _text-2 _text-truncate">{profile?.name}</p>
            <p className="_mb-0 _text-1 _text-truncate">{profile?.email}</p>
          </span>
        </section>

        {userItems.map(item => (
          <AuthHeaderUserMenuItem key={item.id} title={item.title} icon={item.icon} route={item.route} />
        ))}

        <hot-dropdown-menu-item slot="menu" class={`${styles.headerUserItem}`} onClick={() => bootstrap.logout()}>
          <FontAwesomeIcon icon={faSignOut} className="_text-gray-700 _mr-4" />
          <p className="_m-0 _flex-1">{t('header.menu.user.logout')}</p>
        </hot-dropdown-menu-item>
      </div>
    </hot-dropdown>
  )
}

export default AuthHeaderUserMenu
